import React from 'react';
import ModalWrapper from '../../../../app/common/modals/ModalWrapper';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
//import MyTextInput from '../../../../app/common/form/MyTextInput';
import { Button } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../app/common/modals/modalReducer';
import MyTextArea from '../../../../app/common/form/MyTextArea';

export default function SuggestAnEdit({ title }) {
  const dispatch = useDispatch();
  return (
    <ModalWrapper size='mini' header={`Suggest An Edit to ${title}`}>
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        validationSchema={Yup.object({})}
        onSubmit={async (values, { setSubmitting, setErrors }) => {
          try {
            setSubmitting(false);
            dispatch(closeModal());
          } catch (error) {
            setErrors({ auth: 'Incorrect username or password' });
            setSubmitting(false);
            //console.log(error);
          }
        }}
      >
        {({ isSubmitting, isValid, dirty, errors }) => (
          <Form className='ui form'>
            <MyTextArea name='Suggestion ' />
            <Button
              loading={isSubmitting}
              disabled={!isValid || !dirty || isSubmitting}
              type='submit'
              fluid
              size='large'
              color='teal'
              content='Send Suggestion'
            />
          </Form>
        )}
      </Formik>
    </ModalWrapper>
  );
}
